module.exports = __webpack_public_path__ + "img/by.4506d74f.svg";